module.exports = __webpack_public_path__ + "img/courses.fa3d4ca3.svg";